// DS: i3.11.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const VerticalEllipsis: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 12.6667C7 11.9303 7.59695 11.3333 8.33333 11.3333C9.06971 11.3333 9.66667 11.9303 9.66667 12.6667C9.66667 13.403 9.06971 14 8.33333 14C7.59695 14 7 13.403 7 12.6667ZM7 8C7 7.26362 7.59695 6.66667 8.33333 6.66667C9.06971 6.66667 9.66667 7.26362 9.66667 8C9.66667 8.73638 9.06971 9.33333 8.33333 9.33333C7.59695 9.33333 7 8.73638 7 8ZM7 3.33333C7 2.59695 7.59695 2 8.33333 2C9.06971 2 9.66667 2.59695 9.66667 3.33333C9.66667 4.06971 9.06971 4.66667 8.33333 4.66667C7.59695 4.66667 7 4.06971 7 3.33333Z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};
VerticalEllipsis.displayName = 'VerticalEllipsis';

export default VerticalEllipsis;
